import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stepOne } from "../Redux/Asycthunk";
import Footer from "./Footer";
import AppHeader from "./AppHeader";
import { toast } from "sonner";
import imageCompression from "browser-image-compression";

export default function OnboardingStepOne() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
    const business = useSelector((state) => state.auth.business);

  const [businessName, setBusinessName] = useState("");
  const [logoUrl, setLogoUrl] = useState(null);

  const [loading, setLoading] = useState(false);


 



const handleLogoChange = async (e) => {
  const file = e.target.files[0];

  if (!file) return;

  try {
    const compressedFile = await imageCompression(file, {
      maxSizeMB: 2,
      maxWidthOrHeight: 1000,
      useWebWorker: true,
    });

    // Safety check
    if (compressedFile.size > 2 * 1024 * 1024) {
      toast.error("Unable to compress logo below 2MB.");
      e.target.value = "";
      setLogoUrl(null);
      return;
    }

    setLogoUrl(compressedFile);
  } catch (err) {
    toast.error("Unable to process logo.");
    e.target.value = "";
    setLogoUrl(null);
  }
};









  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("businessName", businessName);
      if (logoUrl) formData.append("logoUrl", logoUrl);

      const res = await dispatch(stepOne(formData));
    

      if (res.payload.message === "Business created successfully") {
        window.location.href = "/onboarding-step-two";
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
   }

useEffect(() => {
  if (!business) return;

  if (business.businessName && business.businessName.trim() !== "") {
    window.location.href = "/onboarding-step-two";
  }
}, [business]);

  return (
    <>
   <AppHeader user={{ name: user?.username }} onLogout={handleLogout} />

    <div className="onboarding-container">
      <div className="onboarding-card">

        <p className="progress">Step 1 of 2</p>

        <h2 className="title">Create your business</h2>

        <p className="subtitle">
          This is what customers will see on your QR page.
        </p>

        <form onSubmit={handleSubmit} className="form">

          {/* BUSINESS NAME */}
          <input
            type="text"
            placeholder="Business name"
            value={businessName}
            onChange={(e) => setBusinessName(e.target.value)}
            className="input"
            required
          />
          <p>Upload Your business logo</p>

          {/* LOGO UPLOAD */}
          <input
            type="file"
            accept="image/*"
            onChange={handleLogoChange}
            className="input"
          />

          <button
            className="primary-btn"
            disabled={loading || !businessName}
          >
            {loading ? "Creating..." : "Continue"}
          </button>
        </form>
      </div>

      {/* STYLE */}
      <style jsx>{`
        .onboarding-container {
          height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #0f0f0f;
          color: white;
        }

        .onboarding-card {
          width: 100%;
          max-width: 420px;
          padding: 32px;
          background: #181818;
          border-radius: 20px;
        }

        .progress {
          font-size: 12px;
          opacity: 0.6;
        }

        .title {
          font-size: 24px;
          margin-top: 10px;
        }

        .subtitle {
          font-size: 14px;
          opacity: 0.7;
          margin-bottom: 20px;
        }

        .form {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .input {
          padding: 12px;
          border-radius: 10px;
          border: none;
          background: #222;
          color: white;
        }

        .primary-btn {
          padding: 12px;
          border: none;
          border-radius: 10px;
          background: #6355FE;
          color: white;
          font-weight: bold;
          cursor: pointer;
        }
      `}</style>
    </div>
    <Footer/>
      </>
  );
}